import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import ClientIcon from '@/svg-icons/client';
import DeclinedIcon from '@/svg-icons/declined';
import AcceptedIcon from '@/svg-icons/status-done';
import WaitingIcon from '@/svg-icons/status-waiting';

const SignersSection = ({ signers }) => {
  const RenderIcon = ({ status }) => {
    const s = status.toLowerCase();
    const iconClass = "w-[calc(14px+0.6vw)] h-[calc(14px+0.6vw)] min-w-[18px] min-h-[18px] text-[#858585]";
    if (s === 'pending') return <WaitingIcon viewBox="0 0 55 55" className={iconClass} />;
    if (s === 'finished') return <AcceptedIcon viewBox="0 0 55 55" className={iconClass} />;
    if (s === 'declined') return <DeclinedIcon viewBox="0 0 55 55" className={iconClass} />;
    return null;
  };

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <ClientIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="recipients" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {signers.map((signer, index) => (
          <div key={signer.email} className="mb-[1.5vw] last:mb-0" data-cy="order-details-recipients-signer">
            <p className="font-bold border-b border-[#F0F0F0] pb-[0.3vw] mb-[0.8vw]">
              <FormattedMessage id="recipients" /> <span className="text-[calc(5px+0.4vw)]">{index + 1}</span>
            </p>
            <div className="flex justify-between items-center gap-[1vw]">
              <div className="grow">
                <p className="font-bold m-0" data-cy="order-details-recipients-signer-name">{signer.name}</p>
                <p className="m-0 opacity-80" data-cy="order-details-recipients-signer-email">{signer.email}</p>
              </div>
              <RenderIcon status={signer.status} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

SignersSection.propTypes = {
  signers: PropTypes.array.isRequired,
};

export default SignersSection;
